export enum BluebillywigPlayerStateEnum {
  Playing = 'playing',
  Paused = 'paused',
  Idle = 'idle',
  Loading = 'loading',
}

export enum BlueBillywigPlayerStateIconsEnum {
  playing = 'pause',
  paused = 'play',
  loading = 'play', // eslint-disable-line
  idle = 'rotate-left',
}

export type BluebillywigPlayerState =
  | BluebillywigPlayerStateEnum.Playing
  | BluebillywigPlayerStateEnum.Paused
  | BluebillywigPlayerStateEnum.Idle
  | BluebillywigPlayerStateEnum.Loading;

export interface BluebillywigPlayer {
  on(event: string, callback: () => void): void;
  off(event: string): void;
  play(event: string): void;
  pause(event: string): void;
  seek(position: number): void;
  getState(): BluebillywigPlayerState; // https://support.bluebillywig.com/player-api/events-modes-and-phases/#4-0-states
  getDuration(): number;
  destruct(): void;
}

export interface Bluebillywig {
  Player: new (url: string, options: object) => BluebillywigPlayer;
  players: Array<BluebillywigPlayer>;
}
